/**
 * 对象转换成URL字符串
 */
export const urlEncode = (param, key, encode) => {
	  if(param==null) return '';  
	  var paramStr = '';  
	  var t = typeof (param);  
	  if (t == 'string' || t == 'number' || t == 'boolean') {  
	    paramStr += '&' + key + '=' + ((encode==null||encode) ? encodeURIComponent(param) : param);  
	  } else {  
	    for (var i in param) {  
	      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);  
	      paramStr += urlEncode(param[i], k, encode);  
	    }  
	  }  
  	  return paramStr; 
}
/**
 * 判断浏览器是否支持html5本地存储
 */
export const localStorageSupport = () => {
	return (('localStorage' in window) && window['localStorage'] !== null)
}

/**
 * 存储一个新的localStorage记录
 * @param   {String}    name    key值
 * @param   {String}    content 内容
 */
export const setLocalStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 根据key值获取localStorage的一条记录
 * @param   {String}    name    key值
 */
export const getLocalStore = name => {
	if (!name) return;
	return window.localStorage.getItem(name);
}

/**
 * 根据key值删除localStorage的一条记录
 * @param   {String}    name    key值
 */
export const removeLocalStore = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}

/**
 * 存储一个新的sessionStorage记录
 * @param   {String}    name    key值
 * @param   {String}    content 内容
 */
export const setSessionStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.sessionStorage.setItem(name, content);
}

/**
 * 根据key值获取sessionStorage的一条记录
 * @param   {String}    name    key值
 */
export const getSessionStore = name => {
	if (!name) return;
	return window.sessionStorage.getItem(name);
}

/**
 * 根据key值删除sessionStorage的一条记录
 * @param   {String}    name    key值
 */
export const removeSessionStore = name => {
	if (!name) return;
	window.sessionStorage.removeItem(name);
}


/**
 * 去除数组中假值元素，比如undefined,null,0,"",NaN都是假值
 * @param   {Array}    arr
 * @return  {Array} 
 */
export const compactArray = arr => {
	var index=-1,
        resIndex=-1,
        result=[],
        len=arr?arr.length:0;
    while(++index<len){
        var value=arr[index];
        if(value){
            result[++resIndex]=value;
        }
    }
    return result;
}


/**
 * 判断非null,undefined和空字符以外的值
 * @param   {Mixed}    value
 * @return  {Boolean}
 */
export const isExpect = value => {
	return value!==null && value!==undefined && value!=='';
}

/**
 * ES5中使用全等===会出现以下情况
 * +0 === -0 //true
 * NaN === NaN // false
 * 此方法可以弥补这个缺陷
 * @param   {Mixed}   x
 * @param   {Mixed}   y
 */
export const is = (x, y) => {
	if (x === y) {
        // 针对+0 不等于 -0的情况
        return x !== 0 || 1 / x === 1 / y;
    }
    // 针对NaN的情况
    return x !== x && y !== y;
}


/**
 * 是否为正整数
 * @param   {Mixed}    value
 * @return  {Boolean} 
 */
export const isNumber  = (value) => {
	 var re = /^[0-9]+$/ ;
     return re.test(value)
}



/**
 * 是否为NaN
 * @param   {Mixed}    value
 * @return  {Boolean} 
 */
export const isNaN  = (value) => {
	  return (typeof value === 'number' && isNaN(value));
}

/**
 * 是否为字符串
 * @param   {Mixed}    value
 * @return  {Boolean} 
 */
export const isString  = (value) => {
	  return (typeof value === 'string');
}

/**
 * 复制对象，浅拷贝
 * @param {Object} obj
 * @return {Object} 返回新对象
 */
export const copyObject  = (obj) => {
	  return JSON.parse(JSON.stringify(obj));
}

/**
 * 复制对象，深拷贝
 * @param {Object} obj
 * @return {Object} 返回新对象
 */
export const deepCopy = (source) => {
	var result={}; 
	for (var key in source) { 
		result[key] = typeof source[key]==='object'? this.deepcopy(source[key]): source[key];
	} 
   	return result; 
}

/**
 * 邮箱判断
 * @param   {String}   val
 * @return  {Boolean}
 */
export const isEmail = (val) => {
	var myreg = /^([a-zA-Z0-9]+[_|\_|\.|-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
	if(!myreg.test(val))
	  {
	      return false;
	  }else{
	  	  return true;
	  }
}

/**
 * 手机判断
 * @param   {String}   val
 * @return  {Boolean}
 */
export const isPhone = (val) => {
	var myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
	if(!myreg.test(val))
	  {
	      return false;
	  }else{
	  	  return true;
	  }
}

/**
/**
 * 判断一个对象是否为Dom对象
 * @param   {Object}   obj
 * @return  {Boolean}
 */
export const isDom  = (obj) => {
	return obj && obj.nodeType === 1 && typeof(obj.nodeName) == 'string';
}

/**
 * 将一组值转换为数组
 * @return  {Array} 
 */
export const arrayOf  = arr => {
	return arr.slice.call(arguments);
}

/**
 * 净字符转换成大写
 * @return  {String} 
 */
export const upperCase  = str => {
	const strUpperCase = str.replace(/\b\w+\b/g,function(word){
		return word.substring(0,1).toUpperCase() + word.substring(1);
	});
	return strUpperCase;
}

/**
 * 数组中查找某个元素是否存在
 * @return  {array} 
 */
export const getDictionaryFromArray  = (array,str) => {
	const newArray = array.find(function(value, index, arr) {
		if(typeof(value[str])=="undefined"){ 
			return false;
		} else{
			return true
		}
	})
	if(typeof(newArray)=="undefined"){ 
		return [];
	}else{
		return newArray[str];
	}
}

/*
 * 混合方法，各组件通用的methods
 * （因calendar.vue在html部分使用了stringify方法，所以必须写到methods里）
 */

export const comMixin = {
	methods: {
			getDayCount(year, month) {
				const dict = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
				if(month === 1) {
					if((year % 400 === 0) || (year % 4 === 0 && year % 100 !== 0)) {
						return 29
					}
				}
				return dict[month]
			},
			getNumFormat(day){//1=>01
				return day > 9 ? day : '0' + day
			},
			parseMonth (date) {
			 	const months= ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
		      	return months[date.getMonth()]
			},
			stringify (date, format = 'yyyy-MM-dd') {
		      if (!date) date = this.parse()
		      if (!date) return ''
		      const year = date.getFullYear()
		      const month = date.getMonth() + 1
		      const day = date.getDate()
		      const monthName = this.parseMonth(date)
		      return format
		      .replace(/yyyy/g, year)
		      .replace(/MMMM/g, monthName)
		      .replace(/MMM/g, monthName.substring(0, 3))
		      .replace(/MM/g, ('0' + month).slice(-2))
		      .replace(/dd/g, ('0' + day).slice(-2))
		      .replace(/yy/g, year)
		      .replace(/M(?!a)/g, month)
		      .replace(/d/g, day)
		  	}
  		}
}

/*
 阻止事件冒泡
 * */
export const stopProp = (e) => {
	e = e || window.event;
	if(e.preventDefault) {
		e.preventDefault();
		e.stopPropagation();
	}else{
		e.returnValue = false;
		e.cancelBubble = true;
	}
}


/*
 * 树的模糊查询
 * @param	{Array}   root
 * @param	{String}  str
 * @return  {Array}   result
 */
export const queryTree = (root, str,name) => {
	if(!str) return [];
	let result = [];
	let queue = [];
	let key = name?name:'name'
	queue.push(...root);
	while(queue.length != 0){
		let node = queue.shift();
		if(node[key].indexOf(str) != -1){ 
			node.children = []
			result.push(node);
		}
		/*if(node.children){ 
			queue.push(...node.children);
		}*/
	}
	return result;
}
/*
 将图片转换为base64格式
 * */


export const convertImgToBase64 = (url, callback, outputFormat) => {
		  var canvas = document.createElement('CANVAS'),
		    ctx = canvas.getContext('2d'),
		    img = new Image;
		  img.crossOrigin = 'Anonymous';
		  img.onload = function(){
		    canvas.height = img.height;
		    canvas.width = img.width;
		    ctx.drawImage(img,0,0);
		    var dataURL = canvas.toDataURL(outputFormat || 'image/png');
		    callback.call(this, dataURL);
		    canvas = null; 
		  };
		  img.src = url;
}

/**
 * 获得id**/
export const getModel = (pageid) => {
	pageid = pageid.charAt(0).toUpperCase() + pageid.slice(1);
	return pageid;
}
/*
 map用方法混合
 * */
import {VEHICLE_TRACK} from 'static/constant.js'
export const mapMixin = {
	methods:{
		//获取小车的行驶方向
		getDirection:function(direction){//判断行驶方向  W、E、N、S、EN、ES、WN、WS
		    	if(direction == "" || direction == undefined || direction == null){
					direction = "t"
				}else{
					direction = direction.replace("正",'');
					direction = direction.replace("东",'r');
					direction = direction.replace("西",'l');
					direction = direction.replace("南",'b');
					direction = direction.replace("北",'t');
					
				}
				return direction;
		},
		//根据行驶状态改变图标名称---offline/run/stop/alarm
		getPicName:function (station){
				var iconName = '';
				if(station == null || station == undefined || station.status == null || station.status == undefined || station.status.indexOf('离线') != -1){
					iconName = 'car_offline_' + this.getDirection(info.directionName);
				}else if(station.speed == null || station.speed == undefined || station.speed == '' || station.speed == 0 || station.status.indexOf('停车') != -1){
					iconName = 'car_stop_' + this.getDirection(station.directionName); 
				}else if(station.speed == null || station.speed == undefined || station.speed == '' || station.speed == 0 || station.status.indexOf('报警') != -1){
					iconName = 'car_alarm_' + this.getDirection(station.directionName);
				}else{
					iconName = 'car_run_' + this.getDirection(station.directionName);
				}
				return iconName;
		},
		// 获取拖车图标名称
		getTrailerName:function (station){
			var iconName = '';
			if(station == null || station == undefined || station.status == null || station.status == undefined || station.status.indexOf('离线') != -1){
				iconName = 'trail_offline_' + this.getDirection(info.directionName);
			}else if(station.speed == null || station.speed == undefined || station.speed == '' || station.speed == 0 || station.status.indexOf('停车') != -1){
				iconName = 'trail_stop_' + this.getDirection(station.directionName); 
			}else if(station.speed == null || station.speed == undefined || station.speed == '' || station.speed == 0 || station.status.indexOf('报警') != -1){
				iconName = 'trail_alarm_' + this.getDirection(station.directionName);
			}else{
				iconName = 'trail_leisure_' + this.getDirection(station.directionName);
			}
			return iconName;
		},
		//监控平台-根据几个自动判断图标名称
		picNameByState(info){
			let iconName = ''
			if(info.trackMode == '1'){
				iconName = 'car_follow_' + this.getDirection(info.directionName)
			}else{
				if(info.almOn != '0' && info.almOn != ''){
					iconName = 'car_alarm_' + this.getDirection(info.directionName)
				}else{
					if(info.onState == '1'){
						iconName = 'car_offline_' + this.getDirection(info.directionName)
					}else{
						if(info.runState == '0'){
							iconName = 'car_stop_' + this.getDirection(info.directionName)
						}else{
							iconName = 'car_run_' + this.getDirection(info.directionName)
						}
					}
				}
			}
			return iconName
		},
		getRescuePicName(info){
			let iconName = ''
			if(info.trackMode=='13'){
					iconName = 'car_follow_' + this.getDirection(info.directionName)
				}else if(info.trackMode == '12'){
					iconName = 'car_stop_' + this.getDirection(info.directionName)
				}else{
					iconName = 'car_run_' + this.getDirection(info.directionName)	
				}
				return iconName
		},
		//根据图标名称引入不同base64图片
		getPicUrl:function (iconName){
			if(VEHICLE_TRACK[iconName]){
				return VEHICLE_TRACK[iconName];
			} else {
				return VEHICLE_TRACK.car_offline_t;
			}
		},
		//添加起点和终点标注
		addSEPoint(picUrl,point,map,BMap,word){
			var myIcon = new BMap.Icon(picUrl,new BMap.Size(42,52),{anchor:new BMap.Size(25,50)});
			var marker = new BMap.Marker(point,{icon:myIcon});
			if(word == '警'){
				marker.setOffset(new BMap.Size(5,5))
				marker.setTop(true)
			}
			map.addOverlay(marker);
			return marker
		},
		//改成根据IP定位
		getBrowserPos(map,BMap){
			function myFun(result){
				var cityName = result.name;
				map.setCenter(cityName);
			}
			var myCity = new BMap.LocalCity();
			myCity.get(myFun);
			/*var geolocation = new BMap.Geolocation();
			const that = this;
			geolocation.getCurrentPosition(function(r){
					if(this.getStatus() == BMAP_STATUS_SUCCESS){ 
						map.panTo(r.point);
					}else {
						that.$store.dispatch('tipModalShow','无法获取您当前的位置信息')
					}        
			},{enableHighAccuracy: true})*/
		},
		//设置监控对象marker
		setLocMarker(icon,point,x,y){
			let marker;
			const {map,BMap} = this;  
			const myIcon = new BMap.Icon(icon, new BMap.Size(x, y));
			marker = new BMap.Marker(point, {
				icon: myIcon,
				enableMassClear: false
			})
			return marker; 
		},
		//设置监控对象label
		setLocLabel(content,x,y){
			let label;
			const {map,BMap} = this; 
			label = new BMap.Label(content) 
			label.setOffset(new BMap.Size(x, y));
			label.setStyle({
				border: 'none',
				background: 'none',
				bottom: '5px'
			});
			return label;
		} 
	}
}

/*监控平台底部面板公共方法混合*/
export const bottomTabMixin = {
	methods:{
		switchStrToArr(str){
			let arrow = ''
			switch (str){
					case '正北':
						arrow = 'fa-long-arrow-up'
						break;
					case '正南':
						arrow = 'fa-long-arrow-down'
						break;
					case '正东':
						arrow = 'fa-long-arrow-right'
						break;
					case '正西':
						arrow = 'fa-long-arrow-left'
						break;
					case '东北':
						arrow = 'fa-long-arrow-up tf45deg'
						break;
					case '东南':
						arrow = 'fa-long-arrow-right tf45deg'
						break;
					case '西北':
						arrow = 'fa-long-arrow-left tf45deg'
						break;
					case '西南':
						arrow = 'fa-long-arrow-down tf45deg'
						break;
					default:
						arrow = ''
						break;
			}
			return arrow
		},
		goFile(carNum,carId){//双击某行
				clearTimeout(this.clickTimer)
				if(this.permission.indexOf('monitorVehicle_carListDetail') == -1)//{
					this.addTab(carNum,carId)
				// }else{
				// 	this.$store.dispatch('tipModalShow','由于权限配置问题，您无权查看车辆档案信息')
				// }
		},
		addTab(carNum,carId){//点详细
				if (carNum){
					const obj = {
						name:carNum,
						id:'PageFileCarDetail',
						route:'/indexhome/fileCarDetail' + carId,
						No:'file' + carId,
						params:{id: carId}
					}
					this.$router.push({path:'/indexhome/fileCarDetail' + carId,query:{id: carId}});
					this.$store.dispatch('addTab',obj);
				}else{
					const obj = {
						name:"VE" + carId,
						id:'PageFileCarDetail',
						route:'/indexhome/fileCarDetail' + carId,
						No:'file' + carId,
						params:{id: carId}
					}
					this.$router.push({path:'/indexhome/fileCarDetail' + carId,query:{id: carId}});
					this.$store.dispatch('addTab',obj);
				}
		},
		locating(id){//点定位
				clearTimeout(this.clickTimer)
				const that = this
				this.clickTimer = setTimeout(function(){
					const param = {
						deviceId:id
					}
					that.$store.dispatch('locateVehicle',param)
				},300)
		},
		switchLocMode(str){
			let mode = ''
			switch(str){
				case 'GPS':
					mode = "高精度定位"
					break;
				case 'LBS':
					mode="低精度定位"
					break;
				case 'UNL':
					mode = "未定位"
					break;
				default:
					mode = "未定位"
					break;
				
			}
			return mode
		},
		showStatusList(vId,carNo,vAcc){
			if(this.deviceListComp && this.vehicleDInfo.vId == vId){
				this.$store.dispatch('closeDeviceList')
			}else{
				const obj = {
					vId:vId,
					carNo:carNo,
					vAcc:vAcc
				}
				this.$store.dispatch('showDeviceList',obj)
			} 
		},
		traceAll(){//批量跟踪
			this.operateType = 0 
			const obj = {//点开到跟踪标签
						name:'车辆跟踪视窗',
						id:'PageCarRail',
						route:'/indexhome/carRail',
						No:'carRail'
				}
			this.$router.push(obj.route);
			this.$store.dispatch('addTab',obj);
			this.$http.post(process.env.API_ROOT + '/monitor/track/batch/tracks',{tagpanelId:this.curIndex},{emulateJSON:true})
			.then(res=>{
				this.$store.dispatch('getTrackMap')
			},res=>{
				this.$store.dispatch('tipModalShow', res.body.message)
			})
			.catch(res=>{
				this.$store.dispatch('tipModalShow','请求异常')
			})
		}
	}
}

//更新tiptool后调用的混合方法
export const tipMixin = {
	methods:{
		updateTip(){
				this.$nextTick(function(){
					$('[data-toggle="tooltip"]').tooltip({
					   container:'body'
					})
				 	$('.tip').hover(function(e){
				 		if($(e.currentTarget).attr('tip')==''){
				 			$(e.currentTarget).attr('data-original-title','')
				 			return
				 		}else{
				 			$(e.currentTarget).attr('data-original-title',$(e.currentTarget).attr('tip')).tooltip('fixTitle').tooltip('show')
				 		}
				 	},function(e){
				 		$(e.currentTarget).attr('data-original-title','')
				 	})
				 	$('.list-complete-item').bind('selectstart',function(){
					  	return false
					})
			    })
			}
	}
}

//人保救援混合方法
export const resueMixin = {
	methods:{
		initSubPage(id){
				const that = this;
				var p = new Promise(function(resolve,reject){
					that.$http.get(process.env.API_INSURANCE_ROOT  + '/rescue/orders/' + id)
						.then( res => {
							if(res.body.success){
								const resInfo = res.body.data;		
								resolve(resInfo)
							} else {
								that.openModalMsg(res.body.message);
							}
						}, res => {
							that.openModalMsg(res.body.message);
						}).catch( res => {
							that.openModalMsg(OPERATE_EXCEPTION);
					})
				})
				return p
			}
	}
	
}


//跳转到某个tab
export const goTabMixin = {
	methods:{
		openDidiCarFile(plateNumber,id){
			if(plateNumber) {
					const obj = {
						name: plateNumber,
						id: 'PageFileCarDetail',
						route: '/indexhome/fileCarDetail' + id,
						No: 'file' + id,
						params: {
							id: id
						}
					}
					this.$router.push({
						path: '/indexhome/fileCarDetail' + id,
						query: {
							id: id
						}
					});
					this.$store.dispatch('addTab', obj);
				} else {
					const obj = {
						name: "VE" + id,
						id: 'PageFileCarDetail',
						route: '/indexhome/fileCarDetail' + id,
						No: 'file' + id,
						params: {
							id: id
						}
					}
					this.$router.push({
						path: '/indexhome/fileCarDetail' + id,
						query: {
							id: id
						}
					});
					this.$store.dispatch('addTab', obj);
				}
		},
		openDidiVehicleTrace(){
			const obj = {
					name:'车辆轨迹回放',
					id:'PageTraceVehicle',
					route:'/indexhome/traceVehicle',
					No:'traceVehicle'
				}
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
		},
		openCarRail(){
			const obj = {//点开到跟踪标签
						name:'车辆跟踪视窗',
						id:'PageCarRail',
						route:'/indexhome/carRail',
						No:'carRail'
				}
				this.$router.push(obj.route);
				this.$store.dispatch('addTab',obj);
		}
	}
}

export class GetTime {
	constructor() {
		this.nowTime = new Date()
		this.nowYear = this.nowTime.getFullYear();
		this.nowMonth = this.nowTime.getMonth();
		this.nowDay = this.nowTime.getDate()
		let lastMonth = new Date()
		lastMonth.setDate(1);
		lastMonth.setMonth(lastMonth.getMonth()-1)
		this.lastMonth = lastMonth;
		// this.lastMonth = lastMonth.getMonth();
		// this.lastYear = lastMonth.getFullYear()
	}
	//格式化时间
	getCurrentTime(time) {
		let nowYear = time.getFullYear();
		let nowMonth = time.getMonth()+1;
		let nowDay = time.getDate();
		nowMonth=nowMonth>=10?nowMonth:'0'+nowMonth;
		nowDay=nowDay>=10?nowDay:'0'+nowDay;
		return `${nowYear}-${nowMonth}-${nowDay}`
	}
	//获取月天数
	getMonthDays(myMonth){
		let monthStartDate = new Date(this.nowYear, myMonth, 1);
		let monthEndDate = new Date(this.nowYear, myMonth + 1, 1);
		return (monthEndDate-monthStartDate)/(1000*60*60*24)
	}
	//获取当前季度开始月
	getQuarterStartMonth(){
		let quarterStartMonth=0;
		if (this.nowMonth < 3) {
			quarterStartMonth = 0;
		}
		if (2 < this.nowMonth && this.nowMonth < 6) {
			quarterStartMonth = 3;
		}
		if (5 < this.nowMonth && this.nowMonth < 9) {
			quarterStartMonth = 6;
		}
		if (this.nowMonth > 8) {
			quarterStartMonth = 9;
		}
		return quarterStartMonth;
	}
	//获取本月开始时间	
	getMonthStartDate(){
		let time = new Date(this.nowYear,this.nowMonth,1);
		return this.getCurrentTime(time);
	}
	//获取本月结束时间
	getMonthEndDate(){
		let time = new Date(this.nowYear,this.nowMonth,this.getMonthDays(this.nowMonth))
		return this.getCurrentTime(time);
	}
	//获取上月开始时间
	getLastMonthStartDate(){
		return this.getCurrentTime(this.lastMonth)
	}
	//获取上月结束时间
	getLastMonthEndDate(){
		let days = this.getMonthDays(this.lastMonth.getMonth());
		let year = this.lastMonth.getFullYear();
		let month = this.lastMonth.getMonth();
		let time = new Date(year,month,days)
		return this.getCurrentTime(time)
	}
	//获取当前季度开始日
	getQuarterStartDate(){
		let quarterStartMonth = this.getQuarterStartMonth();
		let time = new Date(this.nowYear,quarterStartMonth,1)
		return this.getCurrentTime(time);
	}
	// 获取当前季度结束时间
	getQuarterEndDate(){
		let quarterEndMonth = this.getQuarterStartMonth()+2;
		let time = new Date(this.nowYear,quarterEndMonth,this.getMonthDays(quarterEndMonth))
		return this.getCurrentTime(time)
	}
	//获取上一季度开始时间
	getPriorSeasonFirstDate(){
		let quarterMonthStart = 0;
		let year = this.nowYear;
		let month;
		//根据当前季度计算上一季度月份
		switch (this.getQuarterStartMonth()) {
			case 0:
				year--;
				month = 9;
				break;
			case 3:
				month = 0;
				break;
			case 6:
				month = 3;
				break;
			case 9:
				month = 6;
				break;
		};
		let time = new Date(year,month,1)
		return this.getCurrentTime(time)
	}
	//获取上一季度结束时间
	getPriorSeasonEndDate(){
		let quarterMonthStart = 0;
		let year = this.nowYear;
		let month;
		//根据当前季度计算上一季度月份
		switch (this.getQuarterStartMonth()) {
			case 0:
				year--;
				month = 9;
				break;
			case 3:
				month = 0;
				break;
			case 6:
				month = 3;
				break;
			case 9:
				month = 6;
				break;
		};
		let time = new Date(year,month+2,this.getMonthDays(month))
		return this.getCurrentTime(time)
	}
}




// WEBPACK FOOTER //
// ./src/util/util.js